class NavSignin {

	constructor() {
		this.signinContainerId = "SigninContainer";
		this.signinFontIconId = "SigninFontIconContainer";
		this.signoutLink = "userSignOutLink";
		this.greetingContainerId = "greetingContainerId";
		this.greetingNameId = "greetingNameId";
		this.providerMenuItem = document.getElementById("provider-icon");
		this.providerMenuItemWatch = document.querySelector(".provider-log-in");
		this.providerMenuItemSignout = document.getElementById("tv-sign-out");
		this.sportsNav = document.querySelector('#global-nav #sports-nav > li');
	}

	getSigninContainerElem () {
		return document.getElementById( this.signinContainerId );
	}

	getSigninFontIconElem () {
		return document.getElementById(this.signinFontIconId);
	}

	getSignoutElem () {
		return document.getElementById(this.signoutLink);
	}

	getGreetingContainer () {
		return document.getElementById(this.greetingContainerId);
	}

	getGreetingNameElem () {
		return document.getElementById(this.greetingNameId);
	}

	doSignin (acct) {
		acct.renderlogin();
	}

	toggleMVPDLoggedIn(acct) {
		if(acct.isMVPDLoggedIn()) {
			this.providerMenuItem.classList.add("logged-in");
			this.providerMenuItemWatch.classList.add("logged-in");
			let providerMenuItemImg = this.providerMenuItem.querySelector("img");
			let mvpd = acct.getMVPDDetails();
			if(mvpd) {
				providerMenuItemImg.src = mvpd.logo;
				providerMenuItemImg.alt = mvpd.name;
			}
		}
	}
	handleMVPDLoggedOut(acct) {
		this.providerMenuItemSignout.addEventListener("click", () => {
			this.providerMenuItem.classList.remove("logged-in");
			this.providerMenuItemWatch.classList.remove("logged-in");
			acct.mvpdLogout();
		})
	}

	doSignout (acct) {
		if (acct.isLoggedIn()) {
			acct.logout();
		}
	}

	toggleSignedin () {
		var that = this,
		signinContainerElem = that.getSigninContainerElem(),
		signinFontIconElem = that.getSigninFontIconElem();
		if (signinContainerElem && signinFontIconElem) {
			signinFontIconElem.className = "user-icon";
			signinContainerElem.className = "signinContainer site-user-controls logged-in";
		}
	}

	toggleSignedout() {
		var that = this,
		signinContainerElem = that.getSigninContainerElem(),
		signinFontIconElem = that.getSigninFontIconElem();
		if (signinContainerElem && signinFontIconElem) {
			signinFontIconElem.className = "user-icon";
			signinContainerElem.className = "signinContainer site-user-controls logged-out";
		}
	}

	toggleUpdate (acct) {
		acct.isLoggedIn() ? this.toggleSignedin() : this.toggleSignedout();
		if (acct.isLoggedIn()) {
			if (acct.getfirstName() !== "" || acct.getlastName() !=="") {
				const name = acct.getfirstName() + " " +  acct.getlastName();
				this.getGreetingContainer().innerHTML = acct.getfirstNameInitial() + acct.getlastNameInitial();
				this.getGreetingNameElem().innerHTML = name;
				this.setAccountName(name.toUpperCase());
			}
			else {
				const name = "Fox Sports Fan";
				this.getGreetingContainer().innerHTML = "FS";
				this.getGreetingNameElem().innerHTML = name;
                this.setAccountName(name.toUpperCase());
			}

		} else {
			this.getGreetingContainer().innerHTML = 'Sign In';
            this.setAccountName('');
		}
	}

	updatelinks () {
		var logoutlink = document.getElementById('FSDNavAcctLogoutLink'),
			loginlink = document.getElementById('FSDNavAcctLoginLink'),
			href = window.location.href;
		if (loginlink) {
			loginlink.href = '/accounts/login?fu=' + encodeURIComponent(href);
		}
	}

	buildSignedInLinks(acct){
		var that = this,
			host = location.host,
			userProfileEditLink = document.getElementById("userProfileEditLink"),
			userAccountEditLink = document.getElementById("userAccountEditLink"),
			userSignoutLink = that.getSignoutElem();

		userSignoutLink.addEventListener('click',function() {
			that.doSignout(acct);
		});
	}

	attach (acct) {
		var that = this,
			signinContainerElem = that.getSigninContainerElem(),
			signinLink = that.getSigninFontIconElem();
		if (signinContainerElem) {
			signinLink.addEventListener('click', function() {
				if (acct.isLoggedIn()) {
					return false;
				} else {
					that.doSignin(acct);
				}
			});
			that.buildSignedInLinks(acct);
		}
	}

	setAccountName(value) {
        const accountName = document.getElementById('accountName');
        if (!accountName) return;

        accountName.innerText = value;
	}
}
export default NavSignin;




